module.exports = __webpack_public_path__ + "img/loop.19724607.png";